import React from 'react'
import { connect } from 'react-redux'

import { firebase } from '../../firebase'
import { resetUser, setAuthUser } from '../../actions'

const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {
        componentDidMount() {
            const { onSetAuthUser, resetUserSettings } = this.props

            firebase.auth.onAuthStateChanged((authUser) => {
                if (authUser) {
                    onSetAuthUser(authUser)
                } else {
                    resetUserSettings()
                }
            })
        }

        render() {
            return (
                <Component />
            )
        }
    }

    return connect(null, {
        onSetAuthUser: setAuthUser,
        resetUserSettings: resetUser,
    })(WithAuthentication)
}

export default withAuthentication



// WEBPACK FOOTER //
// ./src/components/higherOrder/withAuthentication.js